import lang from "@/views/modules/Reminders/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-reminder",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            reminder: {},
            lang:[],
        }
    },
    mounted() {
        this.getReminder();
        this.lang = lang;
    },
    methods: {
        saveReminder() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/reminders/' + self.$route.params.id, self.reminder).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getReminder() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/reminders/' + self.$route.params.id).then(function (response) {
                self.reminder = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}